import CustomTable from "@/components/customTable/CustomTable";
import { Box, Typography } from "@mui/material";
import { useState } from "react";

export default function TableErja({
  totalElements,
  pageable,
  setPageable,
  refetching,
  rowData,
  areaId,
}) {
  const [selection, setSelection] = useState([]);

  const [colDefs] = useState([
    {
      headerName: "ردیف",
      headerCheckboxSelection: true,
      checkboxSelection: true,
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 100,
    },

    {
      field: "name",
      headerName: "نام و نام خانوادگی",
      width: 200,
    },
    {
      field: "identifier",
      headerName: "کد ملی",
      width: 120,
    },
    {
      headerName: "نوع بیمه",
      width: 130,
      cellRenderer: (x, options = {}) => {
        const isMobile = options.mobile ?? false;
        return (
          <Box
            key={`insurance_${x.id}`}
            display="flex"
            alignItems="center"
            justifyContent={isMobile ? "end" : ""}
          >
            <Typography fontFamily="Vazirmatn">
              {x?.data?.insurance === "TAKMIL"
                ? "تکمیلی"
                : x?.data?.insurance === "MILITARY"
                  ? "نیروهای مسلح"
                  : x?.data?.insurance === "TAMIN"
                    ? "تامین اجتماعی"
                    : x?.data?.insurance === "SALAMAT"
                      ? "سلامت"
                      : "ندارد "}{" "}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "phone",
      headerName: "شماره تلفن",
      width: 140,
    },
    {
      field: "fatherName",
      headerName: "نام پدر",
      width: 130,
    },
    {
      headerName: "تاریخ تولد",
      width: 130,
      cellRenderer: (x, options = {}) => {
        const isMobile = options.mobile ?? false;
        return (
          <Box
            key={`birthday_${x.id}`}
            display="flex"
            alignItems="center"
            justifyContent={isMobile ? "end" : "unset"}
          >
            <Typography fontFamily="Vazirmatn">
              {x.data?.birthDate?.split("-", 2)[0]}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "patientNo",
      headerName: "شماره پرونده ",
      width: 140,
    },
  ]);

  return (
    <>
      <CustomTable
        refetching={refetching}
        onPageChange={(pageIndex, pageSize) => {
          setPageable({
            pageIndex: pageIndex,
            pageSize: pageSize,
          });
        }}
        pageSize={pageable.pageSize}
        totalElements={totalElements}
        currentPage={pageable.pageIndex}
        selection={selection}
        setSelection={setSelection}
        rowData={rowData}
        columns={colDefs}
        onCellClicked={(e) => {
          window.open(
            `/parvandeh?areaId=${areaId}&patientIdentifier=${e.data?.identifier}&patientIdentifierType=${e.data?.identifierType}&patientId=${e.data?.id}&tabName=erja`,
            "_blank",
          );
        }}
      />
    </>
  );
}
